import { render, staticRenderFns } from "./customerSelector.vue?vue&type=template&id=1c1ec9b3&scoped=true&"
import script from "./customerSelector.vue?vue&type=script&lang=js&"
export * from "./customerSelector.vue?vue&type=script&lang=js&"
import style0 from "./customerSelector.vue?vue&type=style&index=0&id=1c1ec9b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1ec9b3",
  null
  
)

export default component.exports